<template>
    <div>
      <div class="d-flex align-center mb-2">
        <img :src="captchaUrl" alt="CAPTCHA" class="my-2" @click="refreshCaptcha" style="width: 200px; height: auto; cursor: pointer;" crossorigin="use-credentials" />
        <v-btn @click="refreshCaptcha" class="ml-2 mt-n2 d-flex align-center justify-center" color="primary">
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip activator="parent" location="top">Click to refresh CAPTCHA</v-tooltip>
        </v-btn>
      </div>
      <v-text-field v-model="captchaAnswer" label="Enter CAPTCHA" required />
    </div>
  </template>
  
  <script setup>
import { defineModel, ref, onMounted } from 'vue'
import { config } from '@/config'

const BASE_URL = config.BASE_URL

const captchaUrl = ref(`${BASE_URL}/captcha?${Date.now()}`)
const captchaAnswer = defineModel('captchaAnswer') // using v-model:captchaAnswer in parent

function refreshCaptcha() {
  captchaUrl.value = `${BASE_URL}/captcha?${Date.now()}`
}

// Initialize CAPTCHA on component mount
onMounted(() => {
  refreshCaptcha()
})
</script>
